module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre1",
    attrs: {
      "id": "pgepubid00004"
    }
  }, [_c('a', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "INTRODUCTION"
    }
  }), _c('a', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0002#toc"
    }
  }, [_vm._v("INTRODUCTION.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Dear reader, it is a grave undertaking to write a book, especially is it so in writing a treatise on success and failure, as we have attempted to do in the work we hereby present you. It is a solemn thing to give advice. Experience teaches that no one thing will please everybody; that men's censures are as various as their palates; that some are as deeply in love with vice as others are with virtue. Shall I then make myself the subject of every opinion, wise or weak? Yes, I would rather hazard the censure of some than hinder the good of others.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("There need neither reasons to be given nor apologies to be made where the benefit of our fellow-men is our aim. Henry Clay Trumbull says: \"At no time in the world's history, probably, has there been so general an interest in biography as that which has been shown of late. Just here lies a weighty obligation upon these who write, and those who read, of the lives of men who have done something in the world. It is not enough for us to know "), _c('span', {
    staticClass: "smcap1"
  }, [_vm._v("what")]), _vm._v(" they have done; it belongs to us to discover the "), _c('span', {
    staticClass: "smcap1"
  }, [_vm._v("why")]), _vm._v(" of their works and ways, and to gain some personal benefit from the analysis of their successes and failures. Why was this man great? What general intentions—what special traits led him to success? What ideal stood before him, and by what means did he seek to attain it? Or, on the other hand, what unworthy purpose, what lack of conscience and religious sense, what unsettled method and feeble endeavor stood in the way of the 'man of genius' and his possible achievements?\" In this volume one sees the barefoot boy rise to the eminent statesman, the great millionaire, the honored inventor. How was this accomplished? We believe that a careful study of the different characters, by the light of the author's opinion of the characteristics essential to success, as shown in Department Fifth, will show why they succeeded.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Let the reader follow each character separately, from childhood to manhood, noting carefully the different changes in the career of each and the motives which actuated and brought them about. If this book shall serve to awaken dormant energies in "), _c('span', {
    staticClass: "smcap1"
  }, [_vm._v("one person")]), _vm._v(" who might otherwise have failed, we shall feel abundantly repaid. Doubtless, there are others who are better qualified to write a treatise on such a subject; nevertheless, we have done our best, and this done, we have attained success.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('a', {
    staticClass: "pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "Page_8",
      "title": "[8]"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5ff7c0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0004.vue
// module id = 66
// module chunks = 0